import React from "react";
import ThemeProvider from "./Theme/provider";
import AuthProvider from "./Auth/provider";
import TranslationsProvider from "./Translations/provider";
import ConfirmModalProvider from "./ConfirmModal/provider";
import LoaderBackdropProvider from "./LoaderBackdrop/provider";
import ToastProvider from "./Toast/provider";
import ReloadAnimationProvider from "./ReloadAnimation/provider";
import PermissionPathProvider from "./PermissionPath/provider";
import MaintenanceProvider from "./Maintenance/provider";
import MicrosoftSocialLogin from "./MicrosoftSocialLogin/provider";

const RootProvider: React.FC = ({children}) => (
	<TranslationsProvider>
		<ThemeProvider>
			<ToastProvider>
				<ReloadAnimationProvider>
					<ConfirmModalProvider>
						<MaintenanceProvider>
							<MicrosoftSocialLogin>
								<AuthProvider>
									<LoaderBackdropProvider>
										<PermissionPathProvider>
											{children}
										</PermissionPathProvider>
									</LoaderBackdropProvider>
								</AuthProvider>
							</MicrosoftSocialLogin>
						</MaintenanceProvider>
					</ConfirmModalProvider>
				</ReloadAnimationProvider>
			</ToastProvider>
		</ThemeProvider>
	</TranslationsProvider>
);

export default RootProvider;
